import { Button } from "react-bootstrap";
import { Box, FontFa } from "../../../../components";
import { UserDepartmentModal } from "../../../statistics/modal/user-department-modal";
import { useState } from "react";
import { useSearchParams } from "../../../../hook/use-search-params";

export const DocumentPublishUserDepartment = () => {
  const [openUserDepartmentModal, setOpenUserDepartmentModal] = useState(false);
  const { replaceSearchParams, searchParams } = useSearchParams();

  const handleCloseUserDepartmentModal = () => {
    searchParams.delete("empCode");
    searchParams.delete("deptCode");
    replaceSearchParams(searchParams);
    setOpenUserDepartmentModal(false);
  };

  return (
    <Box
      title="Danh sách tài liệu được triển khai."
      titleRight={<div className="px-4 py-2 d-flex align-items-center"></div>}
    >
      <div className="pt-1 d-flex">
        <h6 className="pt-2">Chọn nhân viên/cơ quan đơn vị</h6>
        <div className="px-4 d-flex align-items-center">
          <Button
            title="Thống kê phân phối theo người dùng"
            className="btn mr-2"
            variant="outline-info"
            onClick={() => setOpenUserDepartmentModal(true)}
          >
            <FontFa name="faUser" size={"xs"} />
          </Button>
        </div>
      </div>
      <UserDepartmentModal isOpen={openUserDepartmentModal} onClose={() => handleCloseUserDepartmentModal()} />
    </Box>
  );
};
